import type { IFetchLocation } from "../types/api/locale";

export const fetchKlaviyoSubscribe = async (email: string, PUBLIC_API_KEY: string, listId: string) => {
  try {
    const url = `https://a.klaviyo.com/client/subscriptions/?company_id=${PUBLIC_API_KEY}`;
    const param = {
      data: {
        type: "subscription",
        attributes: {
          custom_source: "Footer",
          profile: { data: { type: "profile", attributes: { email } } },
        },
        relationships: { list: { data: { type: "list", id: listId || "" } } },
      },
    };

    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json; charset=utf-8", revision: "2024-07-15" },
      body: JSON.stringify(param),
    }).then((res) => res);

    if (response.status === 202) {
      return response;
    }
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    throw new Error(message);
  }
};

/** 현재 위치 가져오기 */
export const fetchLocation = async (): Promise<IFetchLocation | undefined> => {
  const url = "https://api.country.is/";

  try {
    const response = await fetch(url).then((res) => res);
    if (response.status === 200) {
      return (await response.json()) as IFetchLocation;
    }
  } catch (error) {
    console.error("An error occurred:", error);
  }
};
